export const FETCH_PREFIX = 'https://fetch.envl.workers.dev/'
export const CORS_PREFIX = 'https://cors.envl.workers.dev/'
export const CF_KV_URL = 'https://kv-store.envl.workers.dev/'
export const PARSE_RSS = 'https://rss.envl.workers.dev/parse/?url='
export const PARSE_RSS_LIST = 'https://rss.envl.workers.dev/parse-all/'
